import { gql } from 'graphql-tag';
import type { TypedDocumentNode } from '@apollo/client';
import type { IStaffFormData, IStaffFormVars } from '../types';

export const STAFF_FORM: TypedDocumentNode<IStaffFormData, IStaffFormVars> = gql`
  query getRoomsAndStaff($input: ReadUserInput!) {
    readUser(input: $input) {
      id
      firstName
      lastName
      username
      email
      phone
      role
      active
      confirmed
      room {
        id
        title
      }
      welcomed
    }
    viewer {
      id
      site {
        id
        rooms {
          capacity
          created
          groupTypes
          id
          staff {
            id
            lastName
            firstName
            role
          }
          status
          title
          updated
        }
        staff {
          id
          role
        }
      }
    }
  }
`;
